import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAmex = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 48,
	height: 32,
	viewBox: "0 0 48 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			y: 1,
			width: 48,
			height: 30,
			rx: 2,
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M43.8934 27.9088L41.7032 25.5361L39.5131 27.9088H35.2242H25.9162V16.9582H21.5359L27.0112 4.6388H32.304L34.2203 8.83652V4.6388H40.7907L41.8857 7.83272L42.9808 4.6388H47.9086V2.72245C47.9086 1.62739 46.996 0.714844 45.901 0.714844H2.00742C0.912364 0.714844 -0.000183105 1.62739 -0.000183105 2.72245V29.2776C-0.000183105 30.3726 0.912364 31.2852 2.00742 31.2852H45.8097C46.9048 31.2852 47.8173 30.3726 47.8173 29.2776V27.9088H43.8934Z",
			fill: "#0071CE"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M44.5322 26.7225H47.9086L43.4371 21.886L47.9086 17.1407H44.5322L41.7945 20.1522L38.9656 17.1407H35.4979L40.0607 21.886L35.4979 26.7225H38.8744L41.7033 23.6198L44.5322 26.7225Z",
			fill: "#0071CE"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M30.0223 24.4411V22.9811H35.4063V20.7909H30.0223V19.3309H35.4976V17.1407H27.3759V26.7225H35.4976V24.4411H30.0223Z",
			fill: "#0071CE"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M45.3535 15.6807H47.9086V6.09894H43.8934L41.7945 12.1218L39.6044 6.09894H35.4979V15.6807H38.1443V9.01909L40.6082 15.6807H42.8896L45.3535 9.01909V15.6807Z",
			fill: "#0071CE"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M31.3002 6.09891H27.9238L23.726 15.6807H26.6462L27.4675 13.7643H31.8477L32.669 15.6807H35.5892L31.3002 6.09891ZM28.2888 11.6654L29.5663 8.56278L30.8439 11.6654H28.2888Z",
			fill: "#0071CE"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M45.5363 21.6122L47.9089 24.2586L48.0002 18.9658L45.5363 21.6122Z",
			fill: "#0071CE"
		})
	]
});
export default SvgAmex;
